import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=6245b714&scoped=true&"
import script from "./imageViewer.vue?vue&type=script&lang=js&"
export * from "./imageViewer.vue?vue&type=script&lang=js&"
import style0 from "./imageViewer.vue?vue&type=style&index=0&id=6245b714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245b714",
  null
  
)

export default component.exports